import { withNamespace } from '../helper';

const namespace = '@TICKET';

export const GET_TICKETS = withNamespace('GET_TICKETS', namespace);
export const GET_TICKETS_SUCCESS = withNamespace('GET_TICKETS_SUCCESS', namespace);

export const GET_REFERENCE_DATA = withNamespace('GET_REFERENCE_DATA', namespace);
export const GET_REFERENCE_DATA_SUCCESS = withNamespace('GET_REFERENCE_DATA_SUCCESS', namespace);

export const GET_DETAIL = withNamespace('GET_DETAIL', namespace);
export const GET_DETAIL_SUCCESS = withNamespace('GET_DETAIL_SUCCESS', namespace);

export const SUBMIT_DATA = withNamespace('SUBMIT_DATA', namespace);
export const SUBMIT_DATA_SUCCESS = withNamespace('SUBMIT_DATA_SUCCESS', namespace);

export const DELETE = withNamespace('DELETE', namespace);
export const DELETE_SUCCESS = withNamespace('DELETE_SUCCESS', namespace);

export const UPDATE = withNamespace('UPDATE', namespace);

export const SET_LOADING = withNamespace('SET_LOADING', namespace);
export const REQUEST_ERROR = withNamespace('REQUEST_ERROR', namespace);

export const ADD_TICKET_RESPONSE = withNamespace('ADD_TICKET_RESPONSE', namespace);
export const ADD_TICKET_RESPONSE_SUCCESS = withNamespace('ADD_TICKET_RESPONSE_SUCCESS', namespace);
